import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RampLeftIcon(props: IconProps) {
    return <Icon {...props} iconKey={"ramp_left"}/>
}
